import "../AssignmentsLibrary.styles.scss";
import { Modal } from "components";
import React, { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { CSSTransition } from "react-transition-group";
import useAssignmentLibraryUtils from "../useAssignmentLibraryUtils";
import { AssignmentLibraryCard } from ".";
import DeleteAssignmentConfirmationModal from "./DeleteAssignmentConfirmationModal/DeleteAssignmentConfirmationModal";
import { type Assignment } from "types";
import { Button } from "components";

interface AssignmentGalleryProps {
  assignments: Assignment[];
  isDisplayedInModal?: boolean;
  selectedAssignment?: Assignment;
  handleShowAssignmentPreview?: () => void;
  draftGallery?: boolean;
}

const AssignmentGallery = ({
  assignments,
  isDisplayedInModal = false,
  selectedAssignment,
  handleShowAssignmentPreview,
  draftGallery = false,
}: AssignmentGalleryProps) => {
  const {
    patientHasAssignment,
    handleAssignmentButtonClick,
    slug,
    patient,
    group,
  } = useAssignmentLibraryUtils();

  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [currentAssignment, setCurrentAssignment] = useState(null);
  const [showDrafts, setShowDrafts] = useState(true);
  const { t } = useTranslation("common");
  const nodeRef = useRef(null);

  const handleCloseDeleteModal = () => {
    setIsDeleteModalVisible(false);
  };

  const handleOpenDeleteModal = (assignment: any) => {
    setCurrentAssignment(assignment);
    setIsDeleteModalVisible(true);
  };

  return (
    <>
      {assignments.length > 0 && (
        <div
          className={`flex flex-wrap ${draftGallery ? "draft-section" : ""} ${
            !showDrafts ? "draft-section__hidden" : ""
          }`}
        >
          {draftGallery && (
            <div className="draft-section__title">
              <Button
                name="show-drafts"
                value=""
                icon="DownArrow"
                extraClass="button__icon transparent"
                onClick={() => setShowDrafts(!showDrafts)}
              />
              {t("assignment_builder.my_drafts_title")}
              <span>&nbsp;({assignments.length})</span>
            </div>
          )}
          <CSSTransition
            in={showDrafts}
            nodeRef={nodeRef}
            timeout={300}
            classNames={"drafts"}
          >
            <div className="flex flex-wrap" ref={nodeRef}>
              {showDrafts &&
                assignments.map((a) => {
                  const isDraft = a.status === "DRAFT";
                  return (
                    <AssignmentLibraryCard
                      isDraft={isDraft}
                      patientHasAssignment={patientHasAssignment(a.type)}
                      template={a}
                      key={a.uuid}
                      handleAssignmentButtonClick={handleAssignmentButtonClick}
                      slug={slug}
                      patient={patient}
                      handleAssignmentDeleteActionClick={(assignment: any) =>
                        handleOpenDeleteModal(assignment)
                      }
                      group={group}
                      isDisplayedInModal={isDisplayedInModal}
                      handleShowAssignmentPreview={handleShowAssignmentPreview}
                      selected={a.uuid === selectedAssignment?.uuid}
                    />
                  );
                })}
            </div>
          </CSSTransition>
        </div>
      )}
      <Modal isOpen={isDeleteModalVisible} onClose={handleCloseDeleteModal}>
        <DeleteAssignmentConfirmationModal
          assignment={currentAssignment}
          onCancel={handleCloseDeleteModal}
        />
      </Modal>
    </>
  );
};

export default AssignmentGallery;
